{% block sw_cms_block_acris_blog_author_date %}
    <div class="sw-cms-preview-acris-blog-author-date">
        {{ $tc('acris-blog.elements.blogAuthorDate.preview.content') }}
    </div>
{% endblock %}
